import BusinessesMain from 'components/featured/ZoomInfo';

const Businesses = () => {
  return <BusinessesMain />;
};

export default Businesses;
